import { Button, ChipMenu, GenericSuspense, List, useListFilterState, useTranslations, useUrlParamsValueToString } from "@bsm/component";
import { useScholarityListSort } from "../hooks/useScholarityListSort";
import { ScholaritiesQuery } from "../queries/ScholaritiesQuery";
import { TUserStudentScholarity } from "@bsm/graphql";
import { ScholarityListItem } from "../components/ScholarityListItem";
import { Link, Outlet } from "react-router-dom";
import { useSchoolYearMenuItems } from "../hooks/useSchoolYearMenuItems";
import { useMemo } from "react";

export const ScholarityListContainer = () => {

    const [ADD] = useTranslations(i18n)
    const urlParams = useUrlParamsValueToString()
    const sortItems = useScholarityListSort()
    const schoolYearMenuItems = useSchoolYearMenuItems()
    const { filter, setFilter } = useListFilterState(SCHOLARITY_LIST_ID, false);

    const activeSchoolYear = useMemo(() => {
        return {
            schoolYear: filter?.data?.schoolYear
                ? schoolYearMenuItems?.find((item) => item.value === filter?.data?.schoolYear)
                : schoolYearMenuItems[0],
        };
    }, [filter?.data?.schoolYear, schoolYearMenuItems]);

    return (
        <div>
            <div className="flex justify-between mb-4">
                <h3 className="font-semibold">Scholarities</h3>
                <Link to={`-1?${urlParams}`}>
                    <Button
                        className="btn-default"
                        startIcon="fa-solid fa-plus"
                        label={ADD}
                    />
                </Link>
            </div>

            <div className="flex justify-end mb-6">
                <ChipMenu
                    items={schoolYearMenuItems}
                    value={activeSchoolYear?.schoolYear?.value}
                    className="w-35"
                    onClick={(menu) => {
                        setFilter((v: any) => ({
                           ...v, 
                            data: {
                                ...v.data,
                                schoolYear: menu.id !== 0 ? menu.value : undefined,
                            },
                        }));
                    }}
                />
            </div>
            <List
                id={SCHOLARITY_LIST_ID}
                sort={{ items: sortItems }}
                selection={false}
                isUrlParamsState={false}
                GQLRequest={ScholaritiesQuery}
                defaultFilter={{
                    pageSize: 50,
                    page: 0,
                    sort: [{ value: "updatedAt", sort: "DESC" }],
                }}
                onRenderRow={(row: TUserStudentScholarity) => (
                    <ScholarityListItem {...row} />
                )}
            />

            <GenericSuspense>
                <Outlet />
            </GenericSuspense>
        </div>
    );
};

export const SCHOLARITY_LIST_ID = "scholarity-list";

const i18n = [
    'std_add'
];
